import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getInventoryLookup = createAsyncThunk('/thunk/get-inventory', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/inventory/app/v1/get-inventory`,{page:1})
        return response
    } catch (error) {
        throw error
    }
});